<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div class="box" v-else>

      <!-- 背景音乐 -->
      <K-Music :Music="datas.music"></K-Music>

      <viewer @inited="inited" ref="viewer">
      <header>
        <!-- 焦点图 -->
        <div class="banner-box">
          <K-Swiper :datas="datas.focus" :auto="true" v-if="datas.focus && datas.focus_pics_is_show == 1"></K-Swiper>
        </div>

        <div class="QueryResultBox">
          <p class="QueryResult OrangeTrBg" v-if="datas.scan_count <= 1"><span class="icon iconfont icondunpai QueryResultIcon"></span>首次查询 正品认证</p>
          <p class="QueryResult OrangeTrBg" v-else><span class="icon iconfont iconbaojing QueryResultIcon"></span>多次查询 谨防假冒</p>
        </div>

        <div class="LogoBox">
          <div class="logo backImg" :style="{backgroundImage: 'url(' + datas.business.logo + ')'}"><img class="OpacityImg" :src="datas.business.logo"></div>
        </div>
      </header>

      <section>

        <!-- 产品信息 -->
        <div class="ProductBox">
          <div class="ProductName" v-if="datas.prod_name_is_show == 1">{{datas.product.name}}<i class="lable"><i class="lableTxt" v-text="datas.scan_count"></i></i></div>
          <ul class="ProductMain">
            <li v-if="datas.attribute && datas.attribute.ship_date" v-text="'生产日期：'+datas.attribute.ship_date"></li>
            <li v-if="vcode">商品规格：{{vcode}}</li>
            <li v-if="datas.product.attribute" v-for="val in datas.product.attribute" v-text="val.key+'：'+val.value"></li>
            <li v-if="datas.product.unit && datas.prod_name_is_show == 1">商品规格：{{datas.product.unit}}</li>
            <li v-if="datas.product.period && datas.prod_name_is_show == 1">保质期：{{datas.product.period}}</li>
            <li v-if="datas.product.introduce && datas.prod_name_is_show == 1">商品描述：{{datas.product.introduce}}</li>
          </ul>
        </div>
        <div class="wave"></div>

        <!-- 商户信息 -->
        <div class="MainBox" v-if="datas.business && datas.business_is_show == 1">
          <div class="MainTitle">商户信息</div>
          <div class="MainDatasBox">
            <ul class="MainData" v-if="datas.business.company_idcode">
              <li class="MainDataLeft">认证中心：</li>
              <li class="MainDataRight" v-text="datas.business.company_idcode"></li>
            </ul>
            <ul class="MainData">
              <li class="MainDataLeft">商户名称：</li>
              <li class="MainDataRight" v-text="datas.business.name"></li>
            </ul>
            <ul class="MainData">
              <li class="MainDataLeft ProductPeriod">联系人：</li>
              <li class="MainDataRight" v-text="datas.business.linkman"></li>
            </ul>
            <ul class="MainData">
              <li class="MainDataLeft">联系方式：</li>
              <li class="MainDataRight" v-text="datas.business.linkphone"></li>
            </ul>
            <ul class="MainData">
              <li class="MainDataLeft">商户地址：</li>
              <li class="MainDataRight" v-text="datas.business.baddress"></li>
            </ul>
            <ul class="MainData" v-if="datas.business.customize_data" v-for="val in datas.business.customize_data">
              <li class="MainDataLeft" v-text="val.key"></li>
              <li class="MainDataRight" v-text="val.value"></li>
            </ul>
          </div>
        </div>

        <!-- 质检信息 -->
        <div class="MainBox" v-if="datas.batch && datas.batch_is_show == 1 && datas.batch.qc">
          <div class="MainTitle">质检信息</div>
          <div class="MainDatasBox">
            <ul class="MainData" v-for="(item,index) in datas.batch.qc" v-bind:key="index">
              <li class="MainDataLeft" v-text="item.key+'：'"></li>
              <li class="MainDataRight" v-text="item.value" v-if="item.ix == 0"></li>
              <li class="MainDataRight MainDataRightImg backImg" v-else :style="{backgroundImage: 'url(' + item.value + ')'}"><img class="OpacityImg" :src="item.value"></li>
            </ul>
          </div>
        </div>

        <!-- 生产流程 -->
        <div class="MainBox" v-if="datas.process && datas.process_is_show == 1 && datas.trace_is_show == 1">
          <div class="MainTitle">生产流程</div>
          <div class="MainTraceDatasBox">
            <ul class="MainData TraceData" v-for="(item,index) in datas.process" v-bind:key="index">
              <i class="TraceDataDotBox"><i class="TraceDataDot"></i></i>

              <i class="TraceDataDotBox TraceDataDotBottomBox" v-if="index == datas.process.length-1"><i class="TraceDataDot"></i></i>

              <i class="TraceDataLine"></i>
              <li class="MainDataLeft">
                <p v-text="item.name"></p>
                <p class="MainDataHint" v-text="item.date.substring(0,10)"></p>
              </li>
              <li class="MainDataRight MainDataRightImg backImg TraceDataRight" :style="{backgroundImage: 'url(' + item.icon + ')'}"><img class="OpacityImg" :src="item.icon"></li>
            </ul>
          </div>
        </div>

        <!-- 生产流程演示 -->
        <div class="MainBox" v-if="datas.process_demo && datas.process_demo.length > 0 && datas.process_demo_is_show == 1">
          <div class="MainTitle">生产流程</div>
          <div class="MainTraceDatasBox">
            <ul class="MainData TraceData" v-for="(item,index) in datas.process_demo" v-bind:key="index">
              <i class="TraceDataDotBox"><i class="TraceDataDot"></i></i>

              <i class="TraceDataDotBox TraceDataDotBottomBox" v-if="index == datas.process_demo.length-1"><i class="TraceDataDot"></i></i>

              <i class="TraceDataLine"></i>
              <li class="MainDataLeft">
                <p v-text="item.name"></p>
                <p class="MainDataHint" v-text="item.date"></p>
              </li>
              <li class="MainDataRight MainDataRightImg backImg TraceDataRight" :style="{backgroundImage: 'url(' + item.icon + ')'}"><img class="OpacityImg" :src="item.icon"></li>
            </ul>
          </div>
        </div>

        <!-- 经销商流程 -->
        <div class="MainBox" v-if="datas.dealer && datas.dealer_is_show == 1">
          <div class="MainTitle">经销商流程</div>
          <div class="MainTraceDatasBox">
            <ul class="MainData TraceData" v-for="(item,index) in datas.dealer" v-bind:key="index">
              <i class="TraceDataDotBox"><i class="TraceDataDot"></i></i>

              <i class="TraceDataDotBox TraceDataDotBottomBox" v-if="index == datas.dealer.length-1"><i class="TraceDataDot"></i></i>

              <i class="TraceDataLine"></i>
              <li class="MainDataLeft">
                <p v-text="item.name"></p>
                <p class="MainDataHint" v-text="item.date.substring(0,10)"></p>
              </li>
              <li class="MainDataRight MainDataRightImg backImg TraceDataRight" :style="{backgroundImage: 'url(' + item.icon + ')'}"><img class="OpacityImg" :src="item.icon"></li>
            </ul>
          </div>
        </div>

        <!-- 视频信息 -->
        <div class="MainBox" v-if="datas.video && datas.video_is_show == 1">
          <div class="MainTitle">视频信息</div>
          <div class="MainRefDatasBox">
            <video id="VideoBox" class="video-js vjs-big-play-centered vjs-fluid VideoBox" :poster="datas.video.url+'?vframe/jpg/offset/1/w/400/'">
              <source :src="datas.video.url" type="video/mp4" >
            </video>
          </div>
        </div>

        <!-- 自定义栏目 -->
        <div class="MainBox" v-if="datas.ref && datas.ref_is_show == 1" v-for="(item,index) in datas.ref" v-bind:key="index">
          <div class="MainTitle" v-text="item.name"></div>
          <ul class="MainRefDatasBox">
            <li v-for="(val,ix) in item.datas" v-bind:key="ix">
              <a v-if="val.type == 0" v-text="val.data"></a>
              <img v-else :src="val.data">
            </li>
          </ul>
        </div>

        <!-- 自定义底部菜单 -->
        <div class="MainBox MainMenuBox" v-if="datas.menu && datas.menu_is_show == 1">
          <ul class="MainMenuRow CliclStyle" v-for="(item,index) in datas.menu" v-bind:key="index" @click="ClickMenu(item)">
            <li class="MainMenuIcon">
              <i v-if="item.icon" class="backImg" :style="{backgroundImage: 'url(' + item.icon + ')'}"></i>
              <i v-else class="backImg" :style="{backgroundImage: 'url(../../static/images/icon' + item.type + '.png)'}"></i>
              <span class="icon iconfont iconyou MainMenuArrows"></span>
            </li>
            <li class="MainMenuDatas">
              <p class="MainMenuDatasTit onlyOneRow" v-text="item.name"></p>
              <p class="MainMenuDatasTxt onlyOneRow" v-text="item.describe"></p>
            </li>
          </ul>
        </div>

        <div class="shoeContact">客服联系热线：<a style="color:#fff" v-if="datas.business.linkphone" v-text="datas.business.linkphone"></a></div>

      </section>

    </viewer>
    </div>

  </div>
</template>

<script>
import KSwiper from '@/components/Swiper.vue'
import KLoading from '@/components/Loading.vue'
import KMusic from '@/components/Music.vue'
import KForm from '@/components/Form.vue'
import mixin from '../mixins/mixin.js'
import { initDatas } from '../hook/common.js'
export default {
  name: 'Normal02',
  components: {
    KLoading,
    KMusic,
    KForm,
    KSwiper
  },
  mixins: [mixin],
  data () {
    return {
      count:2,
      datas:null,
      vcode: null,
    }
  },
  created () {
    document.querySelector('body').setAttribute('style', 'background-color:#ebeff5');

    //判断是演示还是真实码标
    if (this.$route.query.type == "demo") {
      this.GetDemoDatas(this.$route.query.pid, this.$route.query.rid);  //获取演示模板信息
    } else {
      this.code = this.GetCode();
      const qrCode = sessionStorage.getItem('wwm_QrData');
      if(qrCode){
        this.datas = initDatas(JSON.parse(qrCode));
        this.datas.scan_count = this.datas.scan_count == 1?this.datas.scan_count:this.datas.scan_count-1;
        setTimeout(() => {
          this.initVideo();
        }, 200);
      }else{
        this.GetDatas();
      }
    }
  },
  methods:{
    randomCode (){ //生成随机码
      while(this.vcode<100000){
      	this.vcode = Math.floor(Math.random()*1000000);
      }
    }
  }
}
</script>

<style scoped>
  .banner-box{
    min-height: 8rem;
    background: #EEE;
  }
  header{
    position: relative;
  }
  .QueryResultBox{
    position: absolute;
    bottom:0;left:0;
    right:0;
    z-index: 2;
  }
  .QueryResult{
    font-size:.58rem;
    padding:.15rem .3rem .25rem .3rem;
  }
  .QueryResultIcon{
    font-size:.8rem;
    margin-right: .2rem;
    position: relative;
    top:.02rem;
  }
  .icondunpai{
    top:.1rem;
  }
  .LogoBox{
    position: absolute;
    right:.5rem;
    bottom:-1.5rem;
    z-index: 3;
    width:3rem;
    height:3rem;
    border-radius:.3rem;
    background-color: #FFF;
    box-shadow: 0 0 5px rgba(100,100,100,.5);
  }
  .logo{
    width: 2.8rem;
    height:2.8rem;
    margin:.1rem;
    border-radius: .3rem;
  }
  .ProductBox{
    padding-top:.7rem;
    background-color: #FFF;
  }
  .ProductName{
    padding-left:.5rem;
    font-size:.75rem;
    color:#EB891A;
    position: relative;
  }
  .ProductMain{
    padding:.5rem;
    color:#333;
  }
  .ProductMain li:first-child{
    margin-top:0;
  }
  .ProductMain li{
    font-size:.58rem;
    margin-top:.3rem;
  }
  .lable{
    position: absolute;
    margin-left:.35rem;
    width: .85rem;
    top:.18rem;
    height:1.05rem;
    background-image: url(../../static/images/lable.png);
    background-size: 100% 100%;
  }
  .lableTxt{
    color:#FFF;
    display: table;
    font-weight: 500;
    font-size:.58rem;
    position: relative;
    top:.05rem;
    margin:0 auto;
  }
  .ProductPeriod{
    letter-spacing: .19rem;
  }
  .wave{
    width:100%;
    height:1rem;
    background-size: auto 100%;
    background-image: url(../../static/images/wave.png);
  }

  .MainTitle{
    font-size:.6rem;
    padding:.5rem;
    border-bottom: 1px solid #F3F3F3;
  }
  .MainTitle span{
    position: relative;
    top:1px;
    font-size:.7rem;
    margin-right: .2rem;
  }
  .MainBox{
    color:#333;
    margin-bottom:.5rem;
    background-color: #FFF;
  }
  .MainMenuBox{
    margin-bottom: 0 !important;
  }
  .MainDatasBox{
    padding:.7rem .5rem;
  }
  .MainData{
    padding-top:.7rem;
    line-height:.7rem;
    position: relative;
    font-size: .58rem;
  }
  .MainData:first-child{
    padding-top: 0;
  }
  .MainData:last-child{
    padding-bottom: 0;
  }
  .MainData:after{
    display: block;
    clear: both;
    content: '';
    visibility: hidden;
    height: 0;
  }
  .MainData li{
    float: left;
  }
  .MainDataLeft{
    width: 3.3rem;
  }
  .MainDataRight{
    width: calc(100% - 3.3rem);
    color:#666;
    float: right;
    word-break: break-all;
  }
  .MainDataRightImg{
    width: 7rem !important;
    height: 4rem;
    overflow: hidden;
  }
  .MainDataRightImg img{
    display: block;
    width:100%;
    height:100%;
    opacity: 0;
  }
  .MainDataHint{
    margin-top:.1rem;
    color: #666;
    font-size:.55rem;
  }
  .VideoBox{
    width: 100%;
  }
  .MainRefDatasBox{
    padding:.5rem;
  }
  .MainRefDatasBox li:first-child{
    margin-top:0;
  }
  .MainRefDatasBox li{
    line-height:.9rem;
    font-size:.58rem;
    margin-top:.3rem;
  }
  .MainRefDatasBox li img{
    display: block;
    width: 100%;
  }
  .MainMenuRow{
    padding:.5rem;
    overflow: hidden;
    position: relative;
    border-bottom: 1px solid #F3F3F3;
  }
  .MainMenuRow:last-child{
    border-bottom: 0;
  }
  .MainMenuIcon{
    float: left;
    width: 2.2rem;
    height:2.2rem;
    background-color: #EB891A;
    margin-right:.5rem;
    border-radius: .2rem;
  }
  .MainMenuIcon i{
    display: block;
    width:1.4rem;
    height:1.4rem;
    margin:.4rem;
  }
  .MainMenuDatas{
    float: left;
    width: calc(100% - 3.5rem);
  }
  .MainMenuDatasTit{
    margin-top:.1rem;
    font-size:.58rem;
  }
  .MainMenuDatasTxt{
    font-size:.55rem;
    color:#666;
    margin-top:.15rem;
  }
  .MainMenuArrows{
    position: absolute;
    right:.5rem;
    top:calc(50% - .4rem);
    color:#666;
    font-size:.55rem;
  }
  .CliclStyle:active{
    background:#F6F6F6;
  }
  .CliclStyle:focus{
    background:#FFF;
  }

  /* 溯源信息 */
  .TraceData{
    padding-left:1rem;
    padding-top:0;
    padding-bottom:1rem;
  }
  .TraceData:first-child{
    margin-top:.6rem;
  }
  .MainTraceDatasBox{
    padding:0 .5rem .6rem .5rem;
  }
  .TraceDataRight{
    float: right !important;
  }
  .TraceDataDotBox{
    display: block;
    position: absolute;
    left:0;
    top:0;
    width:.45rem;
    height:.7rem;
    background-color: #FFF;
    z-index: 99;
  }
  .TraceDataDot{
    display: block;
    position: absolute;
    width:.3rem;
    height:.3rem;
    margin-top:.12rem;
    border:2px solid #EB891A;
    border-radius:.3rem;
    z-index: 99;
  }
  .TraceDataDotBottomBox{
    top:auto;
    bottom:0;
  }
  .TraceDataLine{
    display: block;
    position: absolute;
    top:.2rem;
    left:.186rem;
    bottom:0;
    border-left: 2px dashed #EB891A;
    z-index: 98;
  }

  .shoeContact{
    background-color: #EB891A;
    padding: 15px 0px;
    overflow: hidden;
    display: block;
    float: left;
    color: #fff;
    font-size:.68rem;
    text-align: center;
    width: 100%;
    font-family: arial;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/view/Normal02.vue